import { useState, useEffect } from "react";
import { CardTooltip } from "./CardTooltip";
import { fetchCardData } from "@/lib/cardClient";

interface CardNameSpanProps {
  name: string;
  cardMap?: Map<string, Scryfall.Card>;
}

export function CardNameSpan({ name, cardMap }: CardNameSpanProps) {
  const [card, setCard] = useState<Scryfall.Card | null>(null);
  const [loading, setLoading] = useState(false);

  // Check if we already have the card in the map
  useEffect(() => {
    if (cardMap) {
      // Search by name in existing map
      // This is O(N) but map size is usually small (selected cards in current session)
      const found = Array.from(cardMap.values()).find(
        (c) => c.name.toLowerCase() === name.toLowerCase()
      );
      if (found) {
        setCard(found);
        return;
      }
    }

    // Not found in map? Fetch it.
    // Avoid double fetching if we already have it or are loading
    if (!card && !loading) {
      setLoading(true);
      fetchCardData(name)
        .then((data) => {
          if (data) setCard(data);
        })
        .finally(() => setLoading(false));
    }
  }, [name, cardMap]);

  if (card) {
    return (
      <CardTooltip card={card}>
        <a href={`https://scryfall.com/card/${card.id}`} target="_blank" className="font-semibold inline px-1 py-0.5 bg-current/20 hover:bg-current/30 rounded-md cursor-help">
          {name}
        </a>
      </CardTooltip>
    );
  }

  // Fallback: just text (maybe with a different style or loading indicator?)
  return <span className="text-foreground">{name}</span>;
}
